export const GET_CART_DETAILS = "GET_CART_DETAILS";
export const DELETE_FROM_CART = "DELETE_FROM_CART";
export const ADD_TO_CART = "ADD_TO_CART";
